import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LanguagePicker } from './LanguagePicker';
import { CurrencyPicker } from './CurrencyPicker';
import scss from './DrawerPickers.module.scss';
export const DrawerPickers = () => (_jsxs("div", Object.assign({ className: scss.drawerPickers }, { children: [_jsx(LanguagePicker, { mode: "dark" }), _jsx(CurrencyPicker, { mode: "dark" })] })));
